
import Expander from '~/components/elements/Expander';
import TagList from '~/components/catalog/tag/List';

export default {
  name: 'Tag',
  components: {TagList, Expander},
  props: {
    routeGenerator: {
      type: Function,
      required: true,
    },
    list: {
      type: Array,
      required: true,
    },
    showText: {
      type: String,
      default: 'Еще подборки',
    },
    minHeight: {
      type: Number,
      default: 32,
    },
    active: {
      type: String,
      default: '',
    },
    minExpander: {
      type: Number,
      default: 8,
    },
  },
}
